import { AccordionComponent } from '../accordion/accordion.component';
import { AccordionPanelComponent } from '../accordion-panel/accordion-panel.component';
import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  standalone: true,
  imports: [NgClass],
  selector: 'xilo-accordion-title',
  templateUrl: './accordion-title.component.html',
})
export class AccordionTitleComponent {
  @Input() noBorder = false;
  @Input() paddingClass = 'p-4';

  constructor(
    readonly accordion: AccordionComponent,
    readonly accordionPanel: AccordionPanelComponent,
  ) {}
}
